import React, { useEffect, useState } from 'react';

const ScrollProgress: React.FC = () => {
  const [p, setP] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setP(h > 0 ? window.scrollY / h : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        height: 2, zIndex: 9999,
        background: 'rgba(92,225,230,0.08)',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          height: '100%', width: `${p * 100}%`,
          background: 'linear-gradient(90deg, #33bbcf, #5ce1e6, #a8f0ff)',
          boxShadow: '0 0 10px rgba(92,225,230,0.8)',
          transition: 'width 0.08s linear',
        }}
      />
    </div>
  );
};

export default ScrollProgress;
